import ListItemView from './ListItem.view';

export default ListItemView;
